import { css } from 'styled-components';

export default () => css`
	display: inline-block;

	.autosuggest__container {
		position: relative;
	}

	.autosuggest__input {
		border: none;
		box-shadow: none;
	}

	.autosuggest__suggestions-container {
		display: none;
	}

	.autosuggest__suggestions-container--open {
		display: block;
		position: absolute;
		z-index: 2;
	}

	.autosuggest__suggestions-list {
		margin: 0;
		padding: 0;
		list-style-type: none;
	}

	.autosuggest__suggestion {
		cursor: pointer;
	}
`;
